export default {
  app: null,
  apps: null,
  phoneNumbers: null,
  messageTemplate: null,
  messageTemplates: null,
  quickReply: null,
  quickReplies: null,
  defaultMessageTemplates: {
    mensaje_horario_contacto: {
      name: "mensaje_horario_contacto",
      title: "Mensaje de horario de contacto",
      description:
        "Esta plantilla es ideal para que tu lead te de ha conocer el horario que prefiere para comunicarse contigo",
      category: "MARKETING",
      optionButtons: "buttons",
      buttons: [
        { text: "4pm a 6pm", type: "QUICK_REPLY" },
        { text: "6pm a 8pm", type: "QUICK_REPLY" },
        { text: "Otro horario", type: "QUICK_REPLY" },
      ],
      language: "es",
      headerText: "¡Hola!",
      bodyText: "Somos {{business}} ¿En cuál de los siguientes horarios te gustaría que te contacten?",
      footerText: "",
      components: [
        {
          type: "HEADER",
          text: "¡Hola!",
        },
        {
          type: "BODY",
          text: "Somos {{nombre_de_tu_negocio}} ¿En cuál de los siguientes horarios te gustaría que te contacten?",
        },
        {
          type: "BUTTONS",
          buttons: [
            { text: "4pm a 6pm", type: "QUICK_REPLY" },
            { text: "6pm a 8pm", type: "QUICK_REPLY" },
            { text: "Otro horario", type: "QUICK_REPLY" },
          ],
        },
      ],
    },
  },
  WAAssistant: null,
  WAAssistantCurrentStep: {},
  previewFlow: [],
  appId: null,
  schema: null,
};
